import type {
	VehicleAccess,
	VehicleAccessGrant,
	VehicleAccessGrantRemoval,
	VehicleAccessUser,
} from "../../types/vehicle-access.types";
import type {
	VehicleAccessDto,
	VehicleAccessGrantDto,
	VehicleAccessGrantRemovalDto,
	VehicleAccessUserDto,
} from "@/lib/api";
import { cleanWebApiDateString } from "@/utils/date.utilities";

export function toVehicleAccessUser(
	dto: VehicleAccessUserDto
): VehicleAccessUser {
	return {
		remoteId: dto.remoteId,
		displayName: dto.displayName ?? undefined,
		hasActiveMembership: dto.activeMembership === true,
	};
}

export function toVehicleAccessGrant(
	dto: VehicleAccessGrantDto
): VehicleAccessGrant {
	return {
		user: toVehicleAccessUser(dto.user),
		// The API sends `null` for a legacy grant without a level and for a
		// granter that wasn't recorded; normalise both to absent.
		level: dto.level ?? undefined,
		grantedBy: dto.grantedBy ?? undefined,
		// ZonedDateTime arrives as `…Z[UTC]`, which dayjs renders as "Invalid Date".
		dateCreated: cleanWebApiDateString(dto.dateCreated),
		lastUpdated: cleanWebApiDateString(dto.lastUpdated),
	};
}

export function toVehicleAccessGrantRemoval(
	dto: VehicleAccessGrantRemovalDto
): VehicleAccessGrantRemoval {
	return { removed: dto.removed === true };
}

export function toVehicleAccess(dto: VehicleAccessDto): VehicleAccess {
	return {
		vehicleId: dto.vehicleId,
		owner: dto.owner ? toVehicleAccessUser(dto.owner) : undefined,
		// Kept in API order: the API returns them oldest first.
		grants: dto.grants.map(toVehicleAccessGrant),
	};
}
